import { useShake } from '../ShakeProvider';

interface Template {
  id: string;
  name: string;
}

export default function ShakeDropdown() {
  const { templates, loading, isDropdownOpen, setDropdownOpen, openForTemplate } = useShake();

  if (!isDropdownOpen) return null;

  return (
    <div
      className="absolute right-0 top-[calc(100%+8px)] z-50 min-w-[220px] overflow-hidden rounded-xl border border-border/60 bg-card shadow-xl"
      role="menu"
      aria-label="Shake templates"
    >
      <div className="bg-foreground px-3.5 py-2 text-sm font-semibold text-card">
        Templates
      </div>
      {loading && (
        <div className="px-3.5 py-3 text-sm text-muted-foreground">Loading...</div>
      )}
      {!loading && templates.length === 0 && (
        <div className="px-3.5 py-3 text-sm text-muted-foreground">No templates</div>
      )}
      {!loading &&
        templates.map((tpl: Template) => (
          <div
            key={tpl.id}
            className="cursor-pointer border-t border-border/60 px-3.5 py-2.5 text-sm text-accent-foreground transition-colors hover:bg-secondary"
            role="menuitem"
            onClick={() => {
              setDropdownOpen(false);
              openForTemplate(tpl.id);
            }}
          >
            {tpl.name}
          </div>
        ))}
    </div>
  );
}
